import React from "react";
import { useCarConfigSelector } from "../../../../../redux/store";
import useAphTaxInit from "../../../../../hooks/useAphTaxInit";
import SummaryServices from "./SummaryServices";
import SummaryTotals from "./SummaryTotals";
import SummaryCTA from "./SummaryCTA";
import SummaryTabs from "./SummaryTabs";
import { summaryTabVariants, TabsContextProvider } from "./SummaryTabsContext";
import styles from "./Summary.module.scss";
import SummaryInsurance from "./SummaryInsurance";
import SummaryFinance from "./SummaryFinance";
import SummaryCash from "./SummaryCash";
import SummaryTyCode from "./SummaryTyCode";
import SummaryEta from "./SummaryEta";
import SummaryOverview from "./overview/SummaryOverview";
import { SummaryBusinessLeasing } from "./SummaryBusinessLeasing";

const SummaryPanel: React.FC = () => {
    // when the summary is opened the tax should be initialized if needed
    useAphTaxInit();
    const showETA = useCarConfigSelector((state) => state.carConfigSettings.showETA);

    return (
        <TabsContextProvider>
            <div className={styles.panel}>
                <SummaryTabs />

                <div className={styles.list}>
                    <SummaryOverview
                        tabId={`summary-tab-${summaryTabVariants.overview}`}
                        tab={`tab-${summaryTabVariants.overview}`}
                    />
                    <SummaryServices />
                    <SummaryCash
                        tabId={`summary-tab-${summaryTabVariants.cash}`}
                        tab={`tab-${summaryTabVariants.cash}`}
                    />
                    <SummaryFinance
                        tabId={`summary-tab-${summaryTabVariants.finance}`}
                        tab={`tab-${summaryTabVariants.finance}`}
                    />
                    <SummaryInsurance
                        tabId={`summary-tab-${summaryTabVariants.insurance}`}
                        tab={`tab-${summaryTabVariants.insurance}`}
                    />
                    <SummaryBusinessLeasing
                        tabId={`summary-tab-${summaryTabVariants.business}`}
                        tab={`tab-${summaryTabVariants.business}`}
                    />
                    {showETA && <SummaryEta />}
                    <SummaryTyCode />
                </div>

                <div className={styles.sticky}>
                    <div className={styles["sticky-inner"]}>
                        <SummaryTotals />
                        <SummaryCTA />
                    </div>
                </div>
            </div>
        </TabsContextProvider>
    );
};

export default SummaryPanel;
